let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("1UOFZ")).then(() => parcelRequire('8LU3Q'));